import { FC } from "react";
import { ErrorTemplate } from "../blocks/ErrorTemplate";

import {
  TIMEOUT_ERROR_MESSAGE,
  TIMEOUT_ERROR_ADDITIONAL_MESSAGE,
} from "./FrontendTimeoutError";
import { IErrorComponent } from "../ErrorComponent";
import { BackendTimeoutIcon } from "../../../icons/errors";

export const BackendTimeoutError: FC<IErrorComponent> = (props) => {
  return (
    <ErrorTemplate
      {...props}
      icon={BackendTimeoutIcon}
      message={TIMEOUT_ERROR_MESSAGE}
      additionalMessage={TIMEOUT_ERROR_ADDITIONAL_MESSAGE}
    />
  );
};
